import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import { ProtectedRoute } from "@/pages/admin/ProtectedRoute";

import Home from "@/pages/Home";
import Mission from "@/pages/Mission";
import Churches from "@/pages/Churches";
import MinistryArtist from "@/pages/MinistryArtist";
import Directory from "@/pages/Directory";
import BusinessProfile from "@/pages/BusinessProfile";
import JesusUnited from "@/pages/JesusUnited";
import Connect from "@/pages/Connect";
import Fund from "@/pages/Fund";
import GivingSuccess from "@/pages/GivingSuccess";
import GivingCancel from "@/pages/GivingCancel";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/mission" element={<Mission />} />
            <Route path="/churches" element={<Churches />} />
            <Route path="/support" element={<MinistryArtist />} />
            <Route path="/directory" element={<Directory />} />
            <Route path="/directory/:id" element={<BusinessProfile />} />
            <Route path="/jesus-united" element={<JesusUnited />} />
            <Route path="/connect" element={<Connect />} />
            <Route path="/fund" element={<Fund />} />
            <Route path="/giving/success" element={<GivingSuccess />} />
            <Route path="/giving/cancel" element={<GivingCancel />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </AuthProvider>
  );
}

export default App;
